import React from 'react'
import SwalCustom from '../../alert/swal-custom'
import { RiFileExcel2Line } from 'react-icons/ri'

export default function ButtonDownloadExcel({
  ExcelApps,
  fileName = 'template-apps'
}) {
  async function handleDownload() {
    fetch(ExcelApps)
      .then((res) => res.blob())
      .then((file) => {
        let tempUrl = URL.createObjectURL(file)
        const aTag = document.createElement('a')
        aTag.href = tempUrl
        aTag.download = `${fileName}.xlsx`
        aTag.click()
        URL.revokeObjectURL(tempUrl)
        aTag.remove()
      })
      .catch(() => {
        SwalCustom({
          title: 'Error!',
          text: 'Failed to download file'
        })
      })
  }

  return (
    <span
      className="text-decoration-underline text-danger"
      onClick={handleDownload}
    >
      Download Template <RiFileExcel2Line />
    </span>
  )
}
